import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Logging {
  private static LOG_LEVEL_VERBOSE = 5;
  private static LOG_LEVEL_NORMAL = 4;
  private static LOG_LEVEL_WARN = 3;
  private static LOG_LEVEL_ERROR = 2;
  private static LOG_LEVEL_SILENT = 0;

  public static verbose(
    component: string,
    method: string,
    message: string,
    ...args: any[]
  ) {
    if (environment.logLevel >= Logging.LOG_LEVEL_VERBOSE) {
      const stack = new Error().stack;
      //const callerLine = stack.split("\n")[2]; // 0 = Error, 1 = this function, 2 = caller
      //console.log(`[LOG] ${message} — Called from: ${callerLine.trim()}`);
      Logging._log(component, method, message, args);
    }
  }

  public static log(
    component: string,
    method: string,
    message: string,
    ...args: any[]
  ) {
    if (environment.logLevel >= Logging.LOG_LEVEL_NORMAL) {
      Logging._log(component, method, message, args);
    }
  }

  public static warn(
    component: string,
    method: string,
    message: string,
    ...args: any[]
  ) {
    if (environment.logLevel >= Logging.LOG_LEVEL_WARN) {
      Logging._log(component, method, message, args);
    }
  }

  public static error(
    component: string,
    method: string,
    message: string,
    ...args: any[]
  ) {
    if (environment.logLevel >= Logging.LOG_LEVEL_ERROR) {
      Logging._log(component, method, message, args);
    }
  }

  private static _log(
    component: string,
    method: string,
    message: string,
    ...args: any[]
  ) {
    if (environment.logLevel >= Logging.LOG_LEVEL_SILENT) {
      console.log(component + '.' + method + ': ' + message, ...args);

      if (environment.reportLogging) {
        // push log info to backend
        // ...
        console.log('Reporting logging to backend: ', args);
      }
    }
  }
}
